import { Stack, Text, Title } from "@mantine/core";
import { useCounter, useTimeout } from "@mantine/hooks";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/403")({
  component: RouteComponent
});

function RouteComponent() {
  const router = useRouter();
  const [count, { decrement }] = useCounter(5, { min: 0, max: 5 });

  const timer = useTimeout(() => {
    decrement();
  }, 1000);

  useEffect(() => {
    timer.start();

    if (count === 0) {
      router.history.back();
    }

    return () => timer.clear();
  }, [count]);

  return (
    <Stack className="min-h-dvh p-2" justify="center" align="center">
      <div className="text-center">
        <Title order={1} size={64}>
          403 - Acesso Negado
        </Title>

        <Text size="2xl">Você não tem permissão para acessar esta página.</Text>

        <Text c="dimmed" className="mt-4 text-center text-sm text-gray-600">
          Redirecionando para a página inicial em {count} segundo{count > 1 ? "s" : ""}...
        </Text>
      </div>
    </Stack>
  );
}
